export default defineNuxtPlugin(({ $pinia, $axios }) => {
  // Inject $axios into all Pinia stores
  $pinia.use(({ store }) => {
    store.$axios = $axios
  })
})
